import { loginTypes, signLoginParams } from '@/utils/crypto'
import { getLocalStorage } from '@voghion/fe-util'
import { postAction } from './request'

type LoginBaseForm = {
  /**
   * 邮箱
   */
  userName: string
  newsletter?: boolean
}

const publicCacheKey = 'publicKey'


export async function getPublicKeyByCache() {
  const storage = getLocalStorage()
  const cacheData = storage.getItem(publicCacheKey, 0, 3600)
  if (cacheData) {
    return {
      success: true,
      data: {
        publicKey: cacheData
      }
    }
  }
  const res = await getPublicKey()
  if (!res.success) {
    return res
  }
  const publicKey = res.data?.publicKey
  storage.setItem(publicCacheKey, publicKey)
  return res
}

/**
 * 获取公钥
 * @param params
 * @returns
 */
export function getPublicKey<
  T = {
    publicKey: string
  }
>() {
  return postAction('/voghion-user/encrypt/getpublickey')
}

/**
 * 获取用户信息，主要用来检测是否登录
 * @param {*} params
 * @returns
 */
export async function getUserInfo(params = {}) {
  return postAction('/voghion-user/user/info', params)
}

/**
 * 检测邮箱是否已注册
 * @param params
 * @param options
 * @returns
 */
export function emailCheck(params: LoginBaseForm) {
  return postAction('/voghion-user/user/emailRegisterCheck', params)
}

/**
 * 登录结果
 */
export type LoginResult = {
  /**
   * 用户id
   */
  userId: number
  /**
   * 用户 token
   */
  userToken: string
  /**
   * 用户的语言
   */
  language: string
  /**
   * 用户的邮箱
   */
  email: string
  /**
   * 注册时间
   */
  createTimestamp: number
  /**
   * 访问 token，客户端用到
   */
  accessToken: string
}
type ApiResponse<T> = {
  rtn_code?: string
  rtn_ext?: string
  success?: boolean
  rtn_msg?: string
  code?: number
  msg?: string
  data: T
}

export type EmailLoginResponse = ApiResponse<LoginResult>

/**
 * 自动注册用户
 * @param {*} params
 * @returns
 */
export async function autoRegisterUser(params = {}) {
  return postAction('/voghion-user/login/autoRegisterLogin', params)
}

interface LoginForm extends LoginBaseForm {
  /**
   * 密码
   */
  password: string
}

/**
 * 邮件登录
 * @param params
 * @param options
 * @returns
 */
export function emailLogin(params: LoginForm) {
  return new Promise((resolve, reject) => {
    getPublicKeyByCache().then((res: ApiResponse<{ publicKey: string }>) => {
      if (!res.success) {
        reject(res)
      } else {
        const publicKey = res.data.publicKey
        signLoginParams(params, publicKey, loginTypes.email).then((loginParams) => {
          postAction('/voghion-user/user/emailLogin', loginParams).then(resolve).catch(reject)
        }).catch(reject)
      }
    }).catch(reject)
  })
}

/**
 * 发送找回密码验证邮件
 * @param params
 * @param options
 * @returns
 */
export function sendValidation(params: { userName: string; type?: number }) {
  params.type = 2
  return postAction('/voghion-user/login/sendValidation', params)
}

/**
 * 获取loginConfig
 * @param params
 * @param options
 * @returns
 */
export function getLoginConfig(
  params = {},
) {
  return postAction('/cms/abTest/loadConfig', params)
}